"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.chat-thread-sharing.disabled': 'Funkcja udostępniania wątków czatu nie jest dostępna w Twoim obecnym planie.',
};
